import { FocusEventHandler } from "react";

import {
    DropdownWrapper,
    SelectWrapper,
    StyledSelect
} from "components/ui/dropdown/Dropdown.styled";

type DropdownOption = {
    value: string;
    label: string;
};

type DropdownProps = {
    label: string;
    options: Array<DropdownOption>;
    selectedOption?: DropdownOption;
    setSelectedOption: (value?: DropdownOption) => void;
    className?: string;
    onBlur?: FocusEventHandler<HTMLSelectElement>;
};

export function Dropdown({
    label,
    options,
    selectedOption,
    setSelectedOption,
    className,
    onBlur
}: DropdownProps) {
    return (
        <DropdownWrapper className={className}>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor={`${label}-select`}>{label}</label>

            <SelectWrapper>
                <StyledSelect
                    id={`${label}-select`}
                    name={label}
                    onChange={e =>
                        setSelectedOption(
                            options.find(
                                option => option.value === e.target.value
                            )
                        )
                    }
                    value={selectedOption?.value}
                    onBlur={onBlur}
                >
                    {options.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </StyledSelect>
            </SelectWrapper>
        </DropdownWrapper>
    );
}
